/**
 * 起動時の組み立て。
 *
 * `initializeApp` を2回呼ばない(React の StrictMode は effect を二度走らせる)ため、
 * モジュールスコープで1回だけ作って使い回す。
 */
import { AdminAuthService } from './adminAuth';
import { ContentLoader } from './content';
import { missingAdminEnvKeys, readAdminEnv, readAssetsBase, readContentBase } from './env';
import { createAdminFirebase, type AdminFirebase } from './firebase';
import { QuizLoader } from './quiz';

export interface ReadyBootstrap {
  readonly kind: 'ready';
  readonly firebase: AdminFirebase;
  readonly auth: AdminAuthService;
  readonly content: ContentLoader;
  /** まなび(5教科クイズ)。タイピングとは別ファイル群なのでローダも分ける。 */
  readonly quiz: QuizLoader;
  /** 画像・音声の配信元。null なら画面ではサムネイル・再生ボタンを出さない。 */
  readonly assetsBase: string | null;
  readonly projectId: string;
  readonly usingEmulator: boolean;
}

export type Bootstrap =
  ReadyBootstrap | { readonly kind: 'unconfigured'; readonly missing: string[] };

let cached: Bootstrap | null = null;

export function bootstrap(): Bootstrap {
  if (cached) return cached;
  const env = readAdminEnv();
  if (!env) {
    cached = { kind: 'unconfigured', missing: missingAdminEnvKeys() };
    return cached;
  }
  const firebase = createAdminFirebase(env);
  const contentBase = readContentBase();
  cached = {
    kind: 'ready',
    firebase,
    auth: new AdminAuthService(firebase),
    content: new ContentLoader({ baseUrl: contentBase }),
    quiz: new QuizLoader({ baseUrl: contentBase }),
    assetsBase: readAssetsBase(),
    projectId: env.projectId,
    usingEmulator: env.emulator !== null,
  };
  return cached;
}
